// carthelpercomponents/VenueProviderCard.jsx
import AppointmentButton from '../../appointments/AppointmentButton';
import OrderAgreementProofs from '../../documents/OrderAgreementProofs';
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  updateVenueSelection
} from "../../../store/checkoutSlice";

const VenueProviderCard = ({ item, eventId, isCheckout, isOrders }) => {
  const dispatch = useDispatch();

  const [selectedPct, setSelectedPct] = useState(100);

  const pricing = item.pricing || {};
  const venue = item.venue || {};
  const section = item.section || {};
  const provider = item.provider || {};

  const hasDiscount =
    pricing.discountPrice &&
    pricing.discountValidUpto &&
    new Date(pricing.discountValidUpto) > new Date();

  const handleToggle = (value) => {
    if (selectedPct === value) {
      if (!window.confirm("Remove item and order later?")) return;
      setSelectedPct(null);
    } else {
      setSelectedPct(value);
    }

    // Connect redux here
    dispatch(updateVenueSelection({ eventId, percentage: value }));
  };

  const formatCurrency = (amount) => {
    if (amount == null) return "₹0";
    return `₹${Math.round(amount).toLocaleString()}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    if (isNaN(date)) return "N/A";
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const getPricingTypeLabel = (type) => {
    switch (type) {
      case "per_hour":
        return "Per Hour";
      case "per_day":
        return "Per Day";
      case "per_person":
        return "Per Person";
      default:
        return type || "N/A";
    }
  };

  return (
    <div className="card venue-card">
      {isOrders && <OrderAgreementProofs serviceType="venue" cartItemId={item.id} eventId={eventId} providerId={provider.id} />}
      <AppointmentButton providerId={provider.id || item.provider_id || venue.serviceProviderId} providerName={venue.name} eventId={eventId} source="venue" contextId={venue.id} />

      {/* HEADER */}
      <div className="header">
        <div className="venue-info">
          <h4>{venue.name || "Venue"}</h4>
          <span className="section-tag">{section.name || "Section"}</span>
        </div>

        {!isOrders && !item.is_checked_out && item.paid_amount === 0 && (
          <button
            onClick={() => {
              if (!window.confirm("Remove this venue?")) return;
              dispatch(updateVenueSelection({ eventId, percentage: null }));
            }}
            className="remove-btn"
          >
            ❌
          </button>
        )}
      </div>

      {/* VENUE DETAILS */}
      <div className="venue-details">
        <div className="detail-row">
          <span className="detail-label">Provider:</span>
          <span className="detail-value">{provider.name || "N/A"}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Pricing Type:</span>
          <span className="detail-value">{getPricingTypeLabel(item.pricingType)}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Guests:</span>
          <span className="detail-value">{item.noOfGuests || item.guest_count || "N/A"}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Capacity:</span>
          <span className="detail-value">
            {section.minCapacity} - {section.maxCapacity}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">From:</span>
          <span className="detail-value">
            {formatDate(item.fromDate || item.from_date)}
            {item.fromTime && ` ${item.fromTime}`}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">To:</span>
          <span className="detail-value">
            {formatDate(item.toDate || item.to_date)}
            {item.toTime && ` ${item.toTime}`}
          </span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Booking Date:</span>
          <span className="detail-value">{formatDate(item.booking_date)}</span>
        </div>
        <div className="detail-row">
          <span className="detail-label">Timing:</span>
          <span className="detail-value">
            {item.start_time} - {item.end_time}
          </span>
        </div>
      </div>

      {/* FOOD SELECTIONS */}
      {item.foodSelections && item.foodSelections.length > 0 && (
        <div className="selections-box">
          <p className="selections-title">🍽️ Food Selections</p>
          {item.foodSelections.map((food, idx) => (
            <div key={idx} className="selection-item">
              <span>{food.menu?.name || `Menu ${food.menuId}`}</span>
              <span>
                {food.guestCount} guests × {formatCurrency(food.pricePerPerson)}
              </span>
              <span className="selection-total">{formatCurrency(food.subtotal)}</span>
            </div>
          ))}
        </div>
      )}

      {/* DRINK SELECTIONS */}
      {item.drinkSelections && item.drinkSelections.length > 0 && (
        <div className="selections-box">
          <p className="selections-title">🍷 Drink Selections</p>
          {item.drinkSelections.map((drink, idx) => (
            <div key={idx} className="selection-item">
              <span>{drink.drinkOption?.name || `Drink ${drink.drinkOptionId}`}</span>
              <span>
                {drink.guestCount} guests × {formatCurrency(drink.pricePerPerson)}
              </span>
              <span className="selection-total">{formatCurrency(drink.subtotal)}</span>
            </div>
          ))}
        </div>
      )}

      {/* AMOUNT SELECTION */}
      {isCheckout && (
        <div className="amount-selection">
          <p>Choose Amount:</p>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                checked={selectedPct === 100}
                onChange={() => handleToggle(100)}
              />
              Full
            </label>

            <label className="radio-label">
              <input
                type="radio"
                checked={selectedPct === 25}
                onChange={() => handleToggle(25)}
              />
              25%
            </label>

            <label className="radio-label">
              <input
                type="radio"
                checked={selectedPct === 10}
                onChange={() => handleToggle(10)}
              />
              10%
            </label>
          </div>
        </div>
      )}

      <hr />

      {/* PRICE */}
      {hasDiscount ? (
        <div className="price-section">
          <p className="original-price">
            {formatCurrency(pricing.price)}
          </p>
          <p className="discount-price">
            {formatCurrency(pricing.discountPrice)}
          </p>
          <small>
            Valid till {new Date(pricing.discountValidUpto).toDateString()}
          </small>
        </div>
      ) : (
        <p>Total: {formatCurrency(pricing.price)}</p>
      )}

      {/* PRICING BREAKDOWN */}
      <div className="pricing-breakdown">
        {pricing.basePrice > 0 && (
          <div className="price-row">
            <span>Base Price:</span>
            <span>{formatCurrency(pricing.basePrice)}</span>
          </div>
        )}
        {item.foodTotal > 0 && (
          <div className="price-row">
            <span>Food Total:</span>
            <span>{formatCurrency(item.foodTotal)}</span>
          </div>
        )}
        {item.drinkTotal > 0 && (
          <div className="price-row">
            <span>Drink Total:</span>
            <span>{formatCurrency(item.drinkTotal)}</span>
          </div>
        )}
        {pricing.subtotal > 0 && (
          <div className="price-row">
            <span>Subtotal:</span>
            <span>{formatCurrency(pricing.subtotal)}</span>
          </div>
        )}
        <div className="price-row">
          <span>GST: {pricing.gst_percentage || pricing.gstPercentage || 18}%</span>
          <span>{formatCurrency(pricing.gst_amount || pricing.gstAmount || 0)}</span>
        </div>
      </div>

      <hr />

      <p className="total-amount">
        <b>Total Amount: {formatCurrency(pricing.totalAmount)}</b>
      </p>

      {/* PAID */}
      {item.paid_amount > 0 && (
        <div className="paid-status">
          Paid {formatCurrency(item.paid_amount)}
        </div>
      )}

      {/* STATUS */}
      {isCheckout && (
        <div className="payment-status">
          {isOrders ? (
            item.balance_to_be_paid > 0 ? (
              <span className="pending">
                Pending {formatCurrency(item.balance_to_be_paid)}
              </span>
            ) : (
              <span className="paid">Fully Paid</span>
            )
          ) : selectedPct !== null ? (
            <span className="to-pay">
              To Pay: {formatCurrency(item.paymentSummary?.payable_now || 0)}
            </span>
          ) : (
            <span className="order-later">Order Later</span>
          )}
        </div>
      )}
    </div>
  );
};

export default VenueProviderCard;
